function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M13 3c1.105 0 2 .895 2 2v2h2.298c.455 0 .895.155 1.25.438l3.701 2.962c.475.38.751.954.751 1.561V16c0 1.105-.895 2-2 2h-.035c.023.163.035.33.035.5 0 1.933-1.567 3.5-3.5 3.5S14 20.433 14 18.5c0-.17.012-.337.035-.5h-4.07c.023.163.035.33.035.5 0 1.933-1.567 3.5-3.5 3.5S3 20.433 3 18.5c0-.17.012-.337.035-.5H3c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2h10zM6.5 17c-.828 0-1.5.672-1.5 1.5S5.672 20 6.5 20 8 19.328 8 18.5 7.328 17 6.5 17zm11 0c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5zm0-8H15v7h.05c.632-.619 1.496-1 2.45-1 .954 0 1.818.381 2.45 1H21v-4.455L17.5 9zM13 5H3v11h1.05c.632-.619 1.496-1 2.45-1 .954 0 1.818.381 2.45 1H13V5z"
});

function SvgDeliveryWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryWhite);
export default __webpack_public_path__ + "static/media/delivery-white.e3d95352.svg";
export { ForwardRef as ReactComponent };